import { useMemo } from 'react';
import { useGetUsersByQueryQuery } from 'API/UserApi';
import { IGetUser } from 'types/users/IUser';
import { IInternalTransferData } from 'types/order/escrow/IInternalTransferData';
import { IAchPushDisbursementData } from 'types/order/escrow/IAchPushDisbursementData';
import { IEscrowWireDisbursementsData } from 'types/order/escrow/IEscrowWireDisbursementsData';

type PaymentData = IInternalTransferData | IAchPushDisbursementData | IEscrowWireDisbursementsData;

export const useGetPaymentsData = <T extends PaymentData>(payments: T[]) => {
  const voidUsers = useMemo(
    () =>
      payments.filter((t) => t.voiderId).map((check) => ({ userId: check.voiderId, userType: 'ADMIN' }) as IGetUser),
    [payments]
  );

  const { data: users = [] } = useGetUsersByQueryQuery(voidUsers, { skip: !voidUsers.length });

  const usersMap = useMemo(() => new Map(users.map((user) => [user.id, user.name])), [users]);

  const data = useMemo(
    () =>
      payments.map((check) => ({
        ...check,
        voidedBy: check.voiderId ? usersMap.get(check.voiderId) : undefined,
      })),
    [payments, usersMap]
  );

  return data;
};
